<template>
  <div class="setting">

<el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ name: 'allDomain' }">{{$t('allDomain.DomainNames')}}</el-breadcrumb-item>
  <el-breadcrumb-item>{{ subhost }} | {{this.$t('allDomain.config')}} </el-breadcrumb-item>
</el-breadcrumb>

    <!--  -->
    <div class="tab-content">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane lazy :label="$t('allDomain.config')" name="config">
        <SettingsCache name="subhost" :id="id" />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('settings.strategy')" name="strategy">
        <SettingsStrategy name="subhost" :id="id" />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('allDomain.redirect')" name="rewrite">
        <SettingsRewrite name="subhost" :id="id" :subhost="subhost"/>
    </el-tab-pane>
    <!-- <el-tab-pane :label="$t('allDomain.config')" name="first">
      <childDomainConfig :subhost="subhost" :domainHost="rootDomain" type="main" />
    </el-tab-pane> -->
    <!-- <el-tab-pane :label="$t('product.cache')" name="third">
        <CacheSetting />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.strategy')" name="four">
        <CeNueSetting />
    </el-tab-pane> -->
  </el-tabs>
    </div>
  </div>
</template>

<script>
import { apiGetDetail } from "@/service/requestRes";

import domainSettingItem1 from '@/views/domain/domainSettingItem1.vue';
import domainSettingItem2 from '@/views/domain/domainSettingItem2.vue';
// import CacheSetting from '@/views/products/CacheSetting.vue';
// import CeNueSetting from '@/views/products/CeNueSetting.vue';
import childDomainConfig from '@/views/dev/childDomainConfig.vue';
import SettingsCache from '@/views/domain/SettingsCache.vue'
import SettingsStrategy from '@/views/domain/SettingsStrategy.vue'
import SettingsRewrite from '@/views/domain/SettingsRewrite.vue'

export default {
  components: {
    domainSettingItem1,
    domainSettingItem2,
    // CacheSetting,
    // CeNueSetting,
    childDomainConfig,
    SettingsCache,
    SettingsStrategy,
    SettingsRewrite,
  },
  props: {
    rootDomain: String,
  },
  data() {
    return {
      id: this.$route.params.id,
      activeName: 'config',
      detail: null,
      subhost: null,
    };
  },
  mounted(){
    this.getDetail();
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('allDomain.DomainNames'),
          click: () => {
            this.$emit('closePage');
          },
        },
        {
          label: this.$t('allDomain.config'),
        },
      ];
    },
  },
  methods: {
    getDetail() {
      apiGetDetail(
          'subhost', this.id
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.subhost = data.sub_host;
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
  .setting {
    background-color: white;
    padding: 24px;
  }
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
